import { OfferFragment, Offer_Engagement_Type } from '@occc/graphql';

import { readonlyFundingSourceNames } from '@occc-app/offerValidationService/constants';
import { PartialOfferFragment } from './types';

export function isOfferFragment(
  offer: PartialOfferFragment | OfferFragment,
): offer is OfferFragment {
  if ('limits' in offer && 'constraints' in offer) {
    return true;
  }

  return false;
}

export const isOfferReadonly = (offer?: OfferFragment | null) => {
  return offer?.fundingSourceName
    ? readonlyFundingSourceNames.includes(offer?.fundingSourceName)
    : false;
};

export const isOfferClonable = (offer?: OfferFragment | null) => {
  if (offer?.engagementType && [Offer_Engagement_Type.Promocode].includes(offer.engagementType)) {
    return false;
  }
  return offer?.fundingSourceName
    ? !readonlyFundingSourceNames.includes(offer?.fundingSourceName)
    : true;
};
